const mapServiceColor = (service) => {
  return (
    {
      EA: "#4046CA",
      PS: "#F68511",
      ESOCM: "#DE3D82",
      MEA: "#7E84FA",
      BS: "#72E06A",
      RS: "#137AF3",
    }[service.includes("_") ? service.slice(0, service.indexOf("_")) : service] || "#0CB5AE"
  );
};

const mapReserveColor = (index) => {
  const colors = ["#7327D3", "#E8C600", "#CB5D08", "#018F5D"];
  return colors[index] || "#BCE931";
};

const mapServiceToOutputKey = (service) => {
  return {
    energyArbitrage: "EA",
    peakShavingGrid: "PS",
    blackService: "BS",
    ESOCManagement: "ESOCM",
    marketEnergyArbitrage: "MEA",
    renewableEconomicShifting: "RS",
    demandChargeManagement: "DCM",
    demandResponse: "DR",
  }[service];
};

const mapServiceKey = (service) => {
  return (
    `${
      {
        EA: "Energy Arbitrage",
        PS: "Peak Shaving",
        BS: "Black Start",
        MEA: "Market Energy Arbitrage",
        ESOCM: "SoC Management",
        RS: "Renewable Economic Shifting",
        DCM: "Demand Charge Management",
        energy: "Energy",
        rps: "Renewable Peak Shaving",
        DR: "Demand Response",
      }[service.includes("_") ? service.slice(0, service.indexOf("_")) : service]
    }${
      service.includes("_") ? this.snakeToTitleCase(service.slice(service.indexOf("_") + 1)) : ""
    }` || service
  );
};

export { mapServiceKey, mapServiceToOutputKey, mapServiceColor, mapReserveColor };
